var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatsActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.98 10.7902V14.7902C17.9822 15.0408 17.9688 15.2913 17.94 15.5402C17.71 18.2402 16.12 19.5802 13.19 19.5802H12.79C12.6659 19.5806 12.5435 19.6097 12.4325 19.6652C12.3215 19.7207 12.2248 19.8012 12.15 19.9002L10.95 21.5002C10.8483 21.6631 10.7068 21.7973 10.5388 21.8904C10.3709 21.9835 10.182 22.0324 9.99 22.0324C9.79799 22.0324 9.60913 21.9835 9.44119 21.8904C9.27325 21.7973 9.13175 21.6631 9.03 21.5002L7.83 19.9002C7.74995 19.807 7.65212 19.7307 7.54223 19.6758C7.43234 19.6208 7.31259 19.5883 7.19 19.5802H6.79C3.6 19.5802 2 18.7902 2 14.7902V10.7902C2 7.86023 3.35 6.27023 6.04 6.04023C6.28893 6.01141 6.53941 5.99805 6.79 6.00023H13.19C16.38 6.00023 17.9767 7.59689 17.98 10.7902Z",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.98 6.79V10.79C21.98 13.73 20.6334 15.3133 17.94 15.54C17.9689 15.2911 17.9822 15.0406 17.98 14.79V10.79C17.98 7.6 16.3834 6.00333 13.19 6H6.79004C6.53945 5.99783 6.28897 6.01119 6.04004 6.04C6.27004 3.35 7.86004 2 10.79 2H17.19C20.38 2 21.9767 3.59667 21.98 6.79Z",
    fill: "#005386",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatsActive);
export default __webpack_public_path__ + "static/media/IconChatsActive.d886d20b1c3e03856a99e3c5c4d7d074.svg";
export { ForwardRef as ReactComponent };